import { omit } from 'lodash';
import qs from 'qs';
import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as Cross } from '../../../assets/images/cross.svg';
import { ReactComponent as Ellipsis } from '../../../assets/images/ellipsis.svg';
import { OrderItemData } from '../../../components/order-item/order-item-data';
import { TD } from '../../../components/table/table';
import { IOrder } from '../../../graphql/types';
import { ITEM_ID_PARAM, ORDER_ID_PARAM, orderDetailsRoute } from '../route';

export const OrderDetailsTableBody: FC<{ order: IOrder; itemId?: string }> = ({
  order,
  itemId,
}) => {
  const location = useLocation();
  const originalParams = omit(
    qs.parse(location.search, { ignoreQueryPrefix: true }),
    'itemId',
    'uid'
  );

  return (
    <tbody>
      {order.items &&
        order.items.map(item => {
          return (
            <tr key={item.index} data-type="item" data-value={item.index}>
              <OrderItemData item={item} order={order} />
              <TD>
                {itemId !== item.index && (
                  <Link
                    to={orderDetailsRoute(order.soldTo.id, {
                      ...originalParams,
                      [ORDER_ID_PARAM]: order.id,
                      [ITEM_ID_PARAM]: item.index,
                    })}
                    data-type="open-more-info"
                  >
                    <Ellipsis />
                  </Link>
                )}
                {itemId === item.index && (
                  <Link
                    to={orderDetailsRoute(order.soldTo.id, {
                      ...originalParams,
                      [ORDER_ID_PARAM]: order.id,
                    })}
                    data-type="close-more-info"
                  >
                    <Cross />
                  </Link>
                )}
              </TD>
            </tr>
          );
        })}
    </tbody>
  );
};
